export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/

export const isEmailValid = (value) => value.match(EMAIL_REGEX) !== null

export const validateEmail = (value) => {
  const validationMessages = []
  if (value.length <= 0) {
    validationMessages.push('Please enter a valid email address')
  }
  if (value.length && !isEmailValid(value)) {
    validationMessages.push('Please enter a valid email address')
  }
  if (validationMessages.length > 0) {
    return {
      value,
      isValid: false,
      showValidationResult: true,
      validationMessages,
    }
  }
  return {
    value,
    isValid: true,
    showValidationResult: false,
    validationMessages,
  }
}

export const validatePassword = (value) => {
  const validationMessages = []
  if (value.length <= 0) {
    validationMessages.push('Password needs to be at least 8 characters long')
  }
  if (value.length && value.match(/.{8}/) === null) {
    validationMessages.push('Password needs to be at least 8 characters long')
  }
  if (validationMessages.length > 0) {
    return {
      value,
      isValid: false,
      validationMessages,
    }
  }
  return {
    value,
    isValid: true,
    validationMessages,
  }
}

export const validateConfirmedPassword = (value, usedPassword = {}) => {
  const validationMessages = []
  if (value !== usedPassword.value) {
    validationMessages.push('Password do not match')
  }
  if (validationMessages.length > 0) {
    return {
      value,
      isValid: false,
      validationMessages,
    }
  }
  return {
    value,
    isValid: true,
    validationMessages,
  }
}

export const validatePhoneNumber = (value, phoneLength) => {
  const reg = new RegExp(/\d/)

  const minLength = phoneLength[0]
  const maxLength = phoneLength[phoneLength.length - 1]

  if (typeof value === 'undefined' || value.trim().length <= 0 || !reg.test(value)) {
    return {
      isValid: false,
      validationMessages: ['Please fill in Phone Number'],
    }
  }
  if (value.trim().length < minLength) {
    return {
      isValid: false,
      validationMessages: [`Phone number should be minimum ${minLength} digits`],
    }
  }
  if (value.trim().length > maxLength) {
    return {
      isValid: false,
      validationMessages: [`Phone number can be only upto ${maxLength} digits`],
    }
  }
  return {
    isValid: true,
    validationMessages: [],
  }
}

export const validateName = (value, placeholder) => {
  if (value.trim().length <= 0) {
    return {
      value,
      isValid: false,
      validationMessages: [`Please fill in ${placeholder} name`],
    }
  }
  return {
    value,
    isValid: true,
    validationMessages: [],
  }
}
